import { Employee } from '../../models/employee/employee.model';

export interface IEmployeeState {
  employees: Employee[];
  selectedEmployee: Employee | null;
  loading: boolean;
  error: string | null;
}

export const initialEmployeeState: IEmployeeState = {
  employees: [],
  selectedEmployee: null,
  loading: false,
  error: null,
};
